import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_Quot_FinishDates/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_Quot_FinishDates/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_Quot_FinishDates/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Tx_Quot_FinishDates/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_Quot_FinishDates/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/Tx_Quot_FinishDates/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_Quot_FinishDates/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

// 审核通过
export function Approved(keyValue) {
  return request({
    url: '/Tx_Quot_FinishDates/Approved',
    method: 'post',
    data: { paramStr: keyValue }
  });
}

// 审核bu通过
export function AuditNotThrough(keyValue) {
  return request({
    url: '/Tx_Quot_FinishDates/AuditNotThrough',
    method: 'post',
    data: { paramStr: keyValue }
  });
}
